export default "__VITE_ASSET__DLO70_Ml__"